//import { inject } from 'vue';
import type { App, Plugin } from 'vue';
import axios from 'axios';

//import type { AxiosInstance } from 'axios';

export const axiosInstance = axios;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// No Content-Type of our own: axios sends an object as JSON and a FormData as multipart itself;
// a JSON default made it send every upload as JSON, the file lost.
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.baseURL = (window.env?.app?.backend_url || '') + '/api/v1/';

const AxiosPlugin: Plugin = {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	install: (app: App) => {
		//app.config.globalProperties['$axios'] = axiosInstance;
		//app.provide('axios', axiosInstance); // provide 'axios'
	},
};

/*export function useAxios() {
  return inject('axios') as AxiosInstance;
}*/

export default AxiosPlugin;

/*declare module "vue" {
  interface ComponentCustomProperties {
    $axios: AxiosInstance
  }
}*/
